import * as auth from './apis/auth';

export default {
	auth
};
